import React, { useState } from 'react';
import { api } from '../utils/api';

export default function FeedbackButton({ pageContext }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setSending(true);
    try {
      await api.submitFeedback(message.trim(), pageContext);
      setSent(true);
      setMessage('');
      setTimeout(() => { setSent(false); setOpen(false); }, 1800);
    } catch (err) {
      console.error(err);
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <button style={styles.trigger} onClick={() => setOpen(true)} title="Send feedback">
        💬 Feedback
      </button>

      {open && (
        <div style={styles.overlay} onClick={() => setOpen(false)}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={styles.header}>
              <h3 style={styles.title}>💬 Send Feedback</h3>
              <button style={styles.closeBtn} onClick={() => setOpen(false)}>✕</button>
            </div>
            {sent ? (
              <p style={styles.sentMsg}>✓ Thanks - sent!</p>
            ) : (
              <form onSubmit={submit}>
                <textarea
                  style={styles.textarea}
                  placeholder="Bug, idea, annoyance - whatever's on your mind..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  autoFocus
                  rows={5}
                />
                <button style={styles.submitBtn} type="submit" disabled={sending || !message.trim()}>
                  {sending ? 'Sending...' : 'Send'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}

const styles = {
  trigger: {
    background: 'transparent',
    border: '1px solid #1e2a3a',
    color: '#9ca3af',
    borderRadius: '999px',
    padding: '6px 14px',
    fontSize: '0.78rem',
    fontWeight: '600',
    cursor: 'pointer',
    fontFamily: "'Syne', sans-serif",
    whiteSpace: 'nowrap',
  },
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '1rem',
  },
  modal: {
    background: '#111827',
    border: '1px solid #1e2a3a',
    borderRadius: '16px',
    padding: '1.5rem',
    width: '100%',
    maxWidth: '420px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1rem',
  },
  title: {
    margin: 0,
    fontSize: '1rem',
    fontWeight: '700',
    color: '#fff',
    fontFamily: "'Syne', sans-serif",
  },
  closeBtn: {
    background: 'transparent',
    border: 'none',
    color: '#6b7280',
    fontSize: '1rem',
    cursor: 'pointer',
  },
  textarea: {
    width: '100%',
    background: '#0a0f1e',
    border: '1px solid #1e2a3a',
    borderRadius: '10px',
    padding: '0.75rem',
    color: '#fff',
    fontSize: '0.85rem',
    fontFamily: "'Syne', sans-serif",
    resize: 'vertical',
    boxSizing: 'border-box',
    marginBottom: '0.85rem',
  },
  submitBtn: {
    width: '100%',
    background: '#00d4aa',
    color: '#0a0f1e',
    border: 'none',
    borderRadius: '10px',
    padding: '0.7rem',
    fontSize: '0.85rem',
    fontWeight: '700',
    cursor: 'pointer',
    fontFamily: "'Syne', sans-serif",
  },
  sentMsg: {
    color: '#00d4aa',
    fontSize: '0.9rem',
    fontWeight: '700',
    textAlign: 'center',
    padding: '1rem 0',
  },
};
